import React from 'react';

import { REACTION_TYPE } from 'constants/types';

import HeartIcon from './icons/heart.svg';
import LightIcon from './icons/light.svg';
import LikeIcon from './icons/like.svg';

interface ReactionIconProps {
  reactionType: string;
  size?: number;
}

const ReactionIcon: React.FC<ReactionIconProps> = ({
  reactionType,
  size = 20,
}) => {
  let iconSrc;

  switch (reactionType) {
    case REACTION_TYPE.LIKE:
      iconSrc = LikeIcon;
      break;
    case REACTION_TYPE.HEART:
      iconSrc = HeartIcon;
      break;
    case REACTION_TYPE.LIGHT_BULB:
      iconSrc = LightIcon;
      break;
    default:
      return null;
  }

  return <img src={iconSrc} alt={reactionType} width={size} height={size} />;
};

export default ReactionIcon;
